/* ExtraLife — Нова Пошта в кошику: панель «Доставка» (відділення / кур'єр).
   Дані НП: api.novaposhta.ua (публічні методи AddressGeneral, без ключа).
   Результат → атрибути кошика (видно в замовленні) + підстановка в чекаут. */
(() => {
  if (window.__elnp) return;
  const API = 'https://api.novaposhta.ua/v2.0/json/';
  const CITIES = ['Київ', 'Львів', 'Одеса', 'Харків', 'Дніпро'];
  const K = { type: 'Спосіб доставки', city: 'Місто', wh: 'Відділення', addr: 'Адреса',
    cityRef: '_np_city_ref', setRef: '_np_settlement_ref', whRef: '_np_warehouse_ref', strRef: '_np_street_ref', zip: '_np_zip' };
  const T_WH = 'Нова Пошта — відділення / поштомат', T_CR = "Нова Пошта — кур'єр";

  const S = { mode: 'wh', city: null, wh: null, street: null, streetText: '', house: '', flat: '', saved: null };
  const np = (calledMethod, methodProperties) => fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ apiKey: '', modelName: 'AddressGeneral', calledMethod, methodProperties }) })
    .then(r => r.json()).then(d => (d && d.success ? d.data : []));
  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const cityLabel = c => c.Label || [((c.SettlementTypeCode || '') + ' ' + (c.MainDescription || '')).trim(), c.Area ? c.Area + ' обл.' : ''].filter(Boolean).join(', ');
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };

  /* ---------- styles ---------- */
  const css = `
  .elnp{--ink:var(--el-text,#191919);--line:rgba(20,15,10,.14);--mut:#8a8a8a;position:fixed;inset:0;z-index:2147483000;display:none;font:inherit;color:var(--ink)}
  .elnp.is-open{display:block}
  .elnp__bg{position:absolute;inset:0;background:rgba(0,0,0,.35)}
  .elnp--in-dialog{position:absolute;z-index:50}.elnp--in-dialog .elnp__bg{display:none}
  .elnp__sheet{position:absolute;top:0;right:0;bottom:0;width:min(100%,440px);background:#fff;display:flex;flex-direction:column;box-shadow:-8px 0 30px rgba(0,0,0,.12)}
  .elnp--in-dialog .elnp__sheet{width:100%;box-shadow:none}
  .elnp__head{display:flex;align-items:center;gap:12px;padding:16px 20px;border-bottom:1px solid var(--line);flex-shrink:0}
  .elnp__back{all:unset;cursor:pointer;display:grid;place-items:center;width:32px;height:32px;margin-left:-6px;border-radius:8px}
  .elnp__back:hover{background:#f4f4f4}
  .elnp__title{font-size:1.0625rem;font-weight:700;margin:0}
  .elnp__body{flex:1;overflow-y:auto;padding:20px}
  .elnp__lead{margin:0 0 12px;font-size:.9375rem}
  .elnp .elnp__radio{display:flex!important;width:100%;box-sizing:border-box;margin:0;align-items:center;gap:10px;padding:8px 0;cursor:pointer;font-size:.9rem}
  .elnp .elnp__radio input{appearance:none;width:18px;height:18px;margin:0;border:1.5px solid var(--ink);border-radius:50%;display:grid;place-items:center;flex-shrink:0}
  .elnp .elnp__radio input:checked::after{content:"";width:9px;height:9px;border-radius:50%;background:var(--ink)}
  .elnp__cities{display:flex;flex-wrap:wrap;justify-content:space-between;gap:8px 12px;margin:18px 0 14px}
  .elnp__city{all:unset;cursor:pointer;font-size:.9rem;padding-bottom:2px;border-bottom:1.5px solid var(--ink)}
  .elnp__city.is-on{font-weight:700}
  .elnp__f{position:relative;margin-top:12px}
  .elnp__in{box-sizing:border-box;width:100%;height:48px;padding:0 40px 0 14px;border:1px solid var(--line);border-radius:10px;font:inherit;font-size:16px;color:var(--ink);background:#fff;outline:none}
  .elnp__in:focus{border-color:var(--ink)}
  .elnp__in:disabled{background:#f6f6f6;cursor:not-allowed}
  .elnp__in::placeholder{color:var(--mut)}
  .elnp__clr{all:unset;cursor:pointer;position:absolute;right:10px;top:12px;width:24px;height:24px;display:none;place-items:center;color:var(--mut);font-size:18px}
  .elnp__f.has-val .elnp__clr{display:grid}
  .elnp__row{display:flex;gap:10px}.elnp__row>.elnp__f{flex:1}
  .elnp__list{position:absolute;left:0;right:0;top:calc(100% + 4px);z-index:5;max-height:280px;overflow-y:auto;margin:0;padding:4px 0;list-style:none;background:#fff;border:1px solid var(--line);border-radius:10px;box-shadow:0 10px 30px rgba(0,0,0,.12);display:none}
  .elnp__list.is-open{display:block}
  .elnp__opt{padding:10px 14px;cursor:pointer;font-size:.875rem;line-height:1.35}
  .elnp__opt small{display:block;color:var(--mut);font-size:.75rem;margin-top:2px}
  .elnp__opt:hover,.elnp__opt.is-act{background:#f4f4f4}
  .elnp__empty{padding:10px 14px;color:var(--mut);font-size:.85rem}
  .elnp__hint{margin:8px 2px 0;font-size:.75rem;color:var(--mut)}
  .elnp__err{margin:12px 2px 0;font-size:.8rem;color:#b3261e;display:none}.elnp__err.is-on{display:block}
  .elnp__foot{padding:16px 20px;border-top:1px solid var(--line);flex-shrink:0}
  .elnp__done{width:100%;height:52px;border:0;border-radius:10px;background:var(--ink);color:#fff;font:inherit;font-weight:600;font-size:.95rem;letter-spacing:.02em;text-transform:uppercase;cursor:pointer}
  .elnp__done:disabled{opacity:.35;cursor:not-allowed}
  html.elnp-lock{overflow:hidden}`;
  const st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  /* ---------- panel ---------- */
  const P = document.createElement('div');
  P.className = 'elnp'; P.setAttribute('role', 'dialog'); P.setAttribute('aria-modal', 'true'); P.setAttribute('aria-label', 'Доставка');
  P.innerHTML = `
   <div class="elnp__bg" data-x></div>
   <div class="elnp__sheet">
    <div class="elnp__head"><button type="button" class="elnp__back" data-x aria-label="Назад"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg></button><h2 class="elnp__title">Доставка</h2></div>
    <div class="elnp__body">
     <p class="elnp__lead">Оберіть спосіб доставки Новою Поштою</p>
     <label class="elnp__radio"><input type="radio" name="elnp-mode" value="wh" checked> Відділення / поштомат</label>
     <label class="elnp__radio"><input type="radio" name="elnp-mode" value="cr"> Адресна кур'єрська доставка</label>
     <div class="elnp__cities">${CITIES.map(c => `<button type="button" class="elnp__city" data-city="${c}">${c}</button>`).join('')}</div>
     <div class="elnp__f" data-f="city"><input class="elnp__in" data-in="city" placeholder="Оберіть населений пункт" autocomplete="off"><button type="button" class="elnp__clr" data-clr="city" aria-label="Очистити">×</button><ul class="elnp__list" data-list="city"></ul></div>
     <div data-mode="wh">
      <div class="elnp__f" data-f="wh"><input class="elnp__in" data-in="wh" placeholder="Спочатку оберіть населений пункт" autocomplete="off" disabled><button type="button" class="elnp__clr" data-clr="wh" aria-label="Очистити">×</button><ul class="elnp__list" data-list="wh"></ul></div>
      <p class="elnp__hint">Можна шукати за номером або вулицею</p>
     </div>
     <div data-mode="cr" hidden>
      <div class="elnp__f" data-f="street"><input class="elnp__in" data-in="street" placeholder="Вкажіть вулицю" autocomplete="off" disabled><button type="button" class="elnp__clr" data-clr="street" aria-label="Очистити">×</button><ul class="elnp__list" data-list="street"></ul></div>
      <div class="elnp__row"><div class="elnp__f"><input class="elnp__in" data-in="house" placeholder="Будинок" autocomplete="off"></div><div class="elnp__f"><input class="elnp__in" data-in="flat" placeholder="Квартира" autocomplete="off"></div></div>
     </div>
     <p class="elnp__err" data-err></p>
    </div>
    <div class="elnp__foot"><button type="button" class="elnp__done" data-done disabled>Готово</button></div>
   </div>`;
  const $ = s => P.querySelector(s);
  const inp = n => $(`[data-in="${n}"]`), list = n => $(`[data-list="${n}"]`), fld = n => $(`[data-f="${n}"]`);
  const setVal = (n, v) => { inp(n).value = v || ''; fld(n) && fld(n).classList.toggle('has-val', !!v); };
  const err = m => { const e = $('[data-err]'); e.textContent = m || ''; e.classList.toggle('is-on', !!m); };

  function valid() {
    if (!S.city) return false;
    if (S.mode === 'wh') return !!S.wh;
    return !!(S.streetText.trim() && S.house.trim());
  }
  function sync() {
    P.querySelectorAll('[name="elnp-mode"]').forEach(r => (r.checked = r.value === S.mode));
    $('[data-mode="wh"]').hidden = S.mode !== 'wh';
    $('[data-mode="cr"]').hidden = S.mode !== 'cr';
    const wi = inp('wh'), si = inp('street');
    wi.disabled = !S.city; wi.placeholder = S.city ? 'Оберіть відділення / поштомат' : 'Спочатку оберіть населений пункт';
    si.disabled = !S.city; si.placeholder = S.city ? 'Вкажіть вулицю' : 'Спочатку оберіть населений пункт';
    P.querySelectorAll('.elnp__city').forEach(b => b.classList.toggle('is-on', !!S.city && S.city.MainDescription === b.dataset.city));
    $('[data-done]').disabled = !valid();
  }

  /* ---------- dropdown helper ---------- */
  function dropdown(name, search, render, pick) {
    const i = inp(name), l = list(name); let items = [], act = -1, seq = 0;
    const close = () => { l.classList.remove('is-open'); act = -1; };
    const draw = () => {
      l.innerHTML = items.length ? items.map((it, k) => `<li class="elnp__opt${k === act ? ' is-act' : ''}" data-k="${k}">${render(it)}</li>`).join('')
        : `<li class="elnp__empty">${i.value.trim() ? 'Нічого не знайдено' : 'Почніть вводити…'}</li>`;
      l.classList.add('is-open');
    };
    const run = debounce(async () => {
      const my = ++seq; l.innerHTML = '<li class="elnp__empty">Шукаємо…</li>'; l.classList.add('is-open');
      try { const r = await search(i.value.trim()); if (my !== seq) return; items = r; act = -1; draw(); }
      catch (e) { if (my === seq) { l.innerHTML = '<li class="elnp__empty">Не вдалося завантажити. Спробуйте ще раз.</li>'; } }
    }, 280);
    i.addEventListener('input', () => { fld(name) && fld(name).classList.toggle('has-val', !!i.value); pick(null, true); run(); });
    i.addEventListener('focus', () => run());
    i.addEventListener('keydown', e => {
      if (!l.classList.contains('is-open') || !items.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); act = (act + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length; draw(); l.children[act] && l.children[act].scrollIntoView({ block: 'nearest' }); }
      else if (e.key === 'Enter') { e.preventDefault(); if (act >= 0) { pick(items[act]); close(); } }
      else if (e.key === 'Escape') { e.stopPropagation(); close(); }
    });
    l.addEventListener('mousedown', e => { const o = e.target.closest('[data-k]'); if (!o) return; e.preventDefault(); pick(items[+o.dataset.k]); close(); i.blur(); });
    i.addEventListener('blur', () => setTimeout(close, 150));
    return { close };
  }

  const searchCity = async q => {
    if (q.length < 2) return [];
    const d = await np('searchSettlements', { CityName: q, Limit: '20', Page: '1' });
    const a = (d[0] && d[0].Addresses) || [];
    return a.filter(x => x.DeliveryCity && (S.mode === 'wh' ? +x.Warehouses > 0 : x.AddressDeliveryAllowed !== false));
  };
  const pickCity = (c, typing) => {
    if (typing) { if (S.city) { S.city = null; clearWh(); clearStreet(); } sync(); return; }
    S.city = c; setVal('city', c ? cityLabel(c) : ''); clearWh(); clearStreet(); err(''); sync();
    if (c) setTimeout(() => (S.mode === 'wh' ? inp('wh') : inp('street')).focus(), 50);
  };
  const clearWh = () => { S.wh = null; setVal('wh', ''); };
  const clearStreet = () => { S.street = null; S.streetText = ''; setVal('street', ''); };

  dropdown('city', searchCity, c => `${esc(c.Present)}`, pickCity);

  dropdown('wh', async q => {
    if (!S.city) return [];
    const base = { CityRef: S.city.DeliveryCity, Limit: '50', Page: '1', Language: 'UA' };
    let r = await np('getWarehouses', q ? { ...base, FindByString: q } : base);
    if (/^\d+$/.test(q)) {
      const ex = await np('getWarehouses', { ...base, WarehouseId: q });
      r = ex.concat(r.filter(w => !ex.some(e => e.Ref === w.Ref)));
    }
    return r.filter(w => w.WarehouseStatus !== 'Closed' && w.DenyToSelect !== '1');
  }, w => `${esc(w.Description)}`, (w, typing) => {
    if (typing) { S.wh = null; sync(); return; }
    S.wh = w; setVal('wh', w ? w.Description : ''); err(''); sync();
  });

  dropdown('street', async q => {
    if (!S.city || q.length < 2) return [];
    const d = await np('searchSettlementStreets', { SettlementRef: S.city.Ref, StreetName: q, Limit: '20' });
    return (d[0] && d[0].Addresses) || [];
  }, s => esc(s.Present), (s, typing) => {
    if (typing) { S.street = null; S.streetText = inp('street').value; sync(); return; }
    S.street = s; S.streetText = s ? s.Present : ''; setVal('street', S.streetText); sync();
    if (s) setTimeout(() => inp('house').focus(), 50);
  });
  inp('house').addEventListener('input', e => { S.house = e.target.value; sync(); });
  inp('flat').addEventListener('input', e => { S.flat = e.target.value; sync(); });

  P.addEventListener('change', e => { if (e.target.name === 'elnp-mode') { S.mode = e.target.value; err(''); sync(); } });
  P.addEventListener('click', async e => {
    if (e.target.closest('[data-x]')) return close();
    const clr = e.target.closest('[data-clr]');
    if (clr) { const n = clr.dataset.clr; if (n === 'city') pickCity(null); else if (n === 'wh') { clearWh(); sync(); } else { clearStreet(); sync(); } inp(n).focus(); return; }
    const cb = e.target.closest('[data-city]');
    if (cb) {
      const name = cb.dataset.city;
      const r = await searchCity(name).catch(() => []);
      const c = r.find(x => x.MainDescription === name && /^м\.?/.test(x.SettlementTypeCode || '')) || r[0];
      if (c) pickCity(c); else err('Не вдалося завантажити місто. Спробуйте ввести вручну.');
      return;
    }
    if (e.target.closest('[data-done]')) save();
  });
  P.addEventListener('keydown', e => { if (e.key === 'Escape') { e.stopPropagation(); e.preventDefault(); close(); } });

  /* ---------- open / close ---------- */
  let opener = null;
  function open(from) {
    opener = from || null;
    const dlg = from && from.closest('dialog');
    if (dlg) { P.classList.add('elnp--in-dialog'); dlg.appendChild(P); }
    else { P.classList.remove('elnp--in-dialog'); document.body.appendChild(P); document.documentElement.classList.add('elnp-lock'); }
    P.classList.add('is-open'); sync();
    setTimeout(() => (S.city ? null : inp('city').focus()), 60);
  }
  function close() {
    P.classList.remove('is-open'); document.documentElement.classList.remove('elnp-lock');
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
  }

  /* ---------- summary + persistence ---------- */
  const summary = a => {
    if (!a || !a[K.city]) return '';
    return a[K.type] === T_CR ? `Кур'єр: ${a[K.city]}, ${a[K.addr] || ''}` : `${a[K.city]}, ${a[K.wh] || ''}`;
  };
  let loaded = false;
  function paintTriggers() {
    if (!loaded) return;
    const txt = summary(S.saved);
    document.querySelectorAll('[data-elnp-open]').forEach(b => {
      b.classList.toggle('is-filled', !!txt);
      const v = b.querySelector('[data-elnp-val]'), nt = txt || 'Оберіть відділення або адресу'; if (v && v.textContent !== nt) v.textContent = nt;
    });
    if (txt) document.querySelectorAll('[data-elnp-err]:not([hidden])').forEach(x => (x.hidden = true));
  }
  async function save() {
    if (!valid()) return;
    const btn = $('[data-done]'); btn.disabled = true; btn.textContent = 'Зберігаємо…';
    const zip = S.mode === 'wh' ? (S.wh.PostalCodeUA || '') : (S.cityZip || '');
    const addr = S.mode === 'cr' ? [S.streetText.trim(), 'буд. ' + S.house.trim(), S.flat.trim() ? 'кв. ' + S.flat.trim() : ''].filter(Boolean).join(', ') : '';
    const attrs = {
      [K.type]: S.mode === 'wh' ? T_WH : T_CR,
      [K.city]: cityLabel(S.city),
      [K.wh]: S.mode === 'wh' ? S.wh.Description : '',
      [K.addr]: addr,
      [K.cityRef]: S.city.DeliveryCity, [K.setRef]: S.city.Ref,
      [K.whRef]: S.mode === 'wh' ? S.wh.Ref : '', [K.strRef]: S.mode === 'cr' && S.street ? S.street.SettlementStreetRef : '',
      [K.zip]: zip,
      _np_city_name: S.city.MainDescription, _np_mode: S.mode, _np_house: S.mode === 'cr' ? S.house.trim() : '', _np_flat: S.mode === 'cr' ? S.flat.trim() : '', _np_street: S.mode === 'cr' ? S.streetText.trim() : ''
    };
    try {
      if (S.mode === 'cr' && !zip) { const w = await np('getWarehouses', { CityRef: S.city.DeliveryCity, Limit: '1', Page: '1' }).catch(() => []); attrs[K.zip] = (w[0] && w[0].PostalCodeUA) || ''; }
      const r = await fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) });
      if (!r.ok) throw new Error(r.status);
      S.saved = attrs; paintTriggers(); close();
    } catch (e) { err('Не вдалося зберегти. Перевірте з’єднання і спробуйте ще раз.'); }
    finally { btn.textContent = 'Готово'; sync(); }
  }
  const complete = a => !!(a && a[K.city] && (a[K.type] === T_CR ? a[K.addr] : a[K.wh]));

  async function load() {
    try {
      const c = await fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
      const a = c.attributes || {};
      if (complete(a)) {
        S.saved = a; S.mode = a._np_mode === 'cr' ? 'cr' : 'wh';
        S.city = { Label: a[K.city], Present: a[K.city], MainDescription: a._np_city_name || a[K.city], DeliveryCity: a[K.cityRef], Ref: a[K.setRef] };
        setVal('city', a[K.city]);
        if (S.mode === 'wh') { S.wh = { Description: a[K.wh], Ref: a[K.whRef], PostalCodeUA: a[K.zip] }; setVal('wh', a[K.wh]); }
        else { S.streetText = a._np_street || ''; S.street = a[K.strRef] ? { Present: S.streetText, SettlementStreetRef: a[K.strRef] } : null; S.house = a._np_house || ''; S.flat = a._np_flat || ''; S.cityZip = a[K.zip]; setVal('street', S.streetText); inp('house').value = S.house; inp('flat').value = S.flat; }
      }
    } catch (e) {}
    loaded = true; paintTriggers(); sync();
  }

  /* ---------- checkout gate + prefill ---------- */
  function checkoutUrl(a) {
    const p = new URLSearchParams();
    const sa = (k, v) => v && p.set(`checkout[shipping_address][${k}]`, v);
    sa('country', 'UA');
    sa('city', a._np_city_name || a[K.city]);
    sa('address1', a[K.type] === T_CR ? a[K.addr] : a[K.wh]);
    sa('zip', a[K.zip]);
    return (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'checkout?' + p.toString();
  }
  document.addEventListener('click', e => {
    const b = e.target.closest('button[name="checkout"], #checkout');
    if (!b || !document.querySelector('[data-elnp-open]')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (!complete(S.saved)) {
      document.querySelectorAll('[data-elnp-err]').forEach(x => (x.hidden = false));
      const t = b.closest('dialog, form, body').querySelector('[data-elnp-open]') || document.querySelector('[data-elnp-open]');
      open(t); err('Вкажіть, куди доставити замовлення');
      return;
    }
    window.location.href = checkoutUrl(S.saved);
  }, true);

  document.addEventListener('click', e => { const t = e.target.closest('[data-elnp-open]'); if (t) { e.preventDefault(); open(t); } });
  /* після перерендеру кошика — знову підписати кнопку */
  new MutationObserver(debounce(paintTriggers, 50)).observe(document.body, { childList: true, subtree: true });

  window.__elnp = { open, state: S, reload: load };
  load();
})();
